import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
  import MediaUploader from '@/components/common/MediaUploader.vue'
  import { EditorModule } from '@/store/modules/editor'
  import TextRenderer from '@/components/editor/TextRenderer.vue'
  import { useRoute } from 'vue-router/composables'
  import type { PropType } from 'vue'
  import type { LessonDownloadable } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EditDownloadableDownloadUrl',
  props: {
    downloadUrl: {
      type: String,
      required: true,
    },
    editorState: String as PropType<'lessonDownloadable'>,
    editorProperty: String as PropType<keyof LessonDownloadable>,
  },
  setup(__props) {

const props = __props;

  

  const route = useRoute()
  const url = ref(props.downloadUrl || '')
  const downloadData = ref('')

  const setDownloadUrl = (fileData: string, downloadUrl: string) => {
    url.value = downloadUrl
    EditorModule.setDownloadableDownloadUrl(downloadUrl)

    downloadData.value = fileData
    EditorModule.setDownloadableRealDownloadData(fileData)
  }

  const resetUrl = () => {
    url.value = ''
    downloadData.value = ''
  }

  watch(
    () => props.downloadUrl,
    (downloadUrl) => {
      url.value = downloadUrl
    },
  )

  watch(url, (url) => {
    if (props.editorState && props.editorProperty) {
      EditorModule.setEditableState({
        key: `${props.editorState}${props.editorProperty}`,
        path: route.path,
        state: props.editorState,
        property: props.editorProperty,
        value: {
          url,
          downloadData: downloadData.value,
        },
      })
    }
  })

return { __sfc: true,props, route, url, downloadData, setDownloadUrl, resetUrl, ref, watch, MediaUploader, EditorModule, TextRenderer, useRoute }
}

})